export default "__VITE_ASSET__CtTFp1oH__"